import { format, parseISO } from 'date-fns'
import { isEmpty } from 'lodash'

// =============================================================================
// Pure helpers for the right-side drawer.
// =============================================================================

// Format a version's createdAt into "MMM d, yyyy" — same as the info pane.
export const formatVersionDate = (iso) => {
  if (!iso) {
    return '—'
  }
  try {
    return format(parseISO(iso), 'MMM d, yyyy')
  } catch (parseError) {
    return '—'
  }
}

// The latest version in a resolved versions list. Picks by highest `version`
// number rather than array position — the two backend sources order
// differently (the node config is oldest-first; `/nodes/versions` is
// newest-first), so position isn't reliable.
export const latestVersion = (versions) => {
  if (isEmpty(versions)) {
    return null
  }
  return versions.reduce((latest, entry) =>
    (entry?.version || 0) > (latest?.version || 0) ? entry : latest
  )
}

// The version the drawer is currently displaying: the peek override (if set on
// this node) or the latest version.
export const getActiveVersion = (versions, drawerVersionOverride) => {
  if (isEmpty(versions)) {
    return null
  }
  if (drawerVersionOverride !== null && drawerVersionOverride !== undefined) {
    const found = versions.find((entry) => entry.version === drawerVersionOverride)
    if (found) {
      return found
    }
  }
  return latestVersion(versions)
}

// True when the drawer is peeking a non-latest version (read-only mode).
export const isReadOnlyForOverride = (versions, drawerVersionOverride) => {
  if (drawerVersionOverride === null || drawerVersionOverride === undefined) {
    return false
  }
  const latest = latestVersion(versions)
  if (!latest) {
    return false
  }
  return drawerVersionOverride !== latest.version
}

// Tab visibility per node type. Returns the array of tab keys for the tab nav.
// Decision and tool/exit nodes have a custom view rather than a tab set;
// callers handle those types separately.
export const getVisibleTabs = (node) => {
  if (!node) {
    return []
  }
  switch (node.type) {
    case 'greeting':
    case 'prompt':
      return ['prompt', 'tools', 'variables']
    case 'subagent':
      return ['prompt', 'model', 'handoffs', 'tools', 'variables']
    default:
      return []
  }
}

export const TAB_LABELS = {
  prompt: 'Prompt',
  model: 'LLM settings',
  handoffs: 'Handoffs',
  tools: 'Tools',
  variables: 'Variables',
}
